import { IS_LOADING } from '../../constants/index';

export const setIsLoading = value => ({
  type: IS_LOADING,
  payload: { value }
});
